import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=873719f2"
import script from "./PeopleSearch.vue?vue&type=script&lang=js"
export * from "./PeopleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports